
<div class="d-flex bd-highlight" *ngIf="!normalLoader && max-val>=0">
    <div class="p-0 flex-shrink-1 bd-highlight" >
      <div >

        <!-- <span class="badge badge-pill badge-info mr-1  position-absolute blinking-bedge" >{{modemTestMapping?.[imei]=='continuous'?'RF':
          modemTestMapping?.[imei]=='iperf_continuous'?'IPERF':''}}</span> -->
        <span  placement="top" [ngbTooltip]="testType=='continuous'?'RF':
        testType=='iperf_continuous'?'IPERF':testType"
         >{{imeiCopy}}</span>
      </div>
      </div>
    <div class="p-1 w-100 bd-highlight"> <ngb-progressbar [max]="max" [value]="max-val"></ngb-progressbar></div>
    <div class="p-0 flex-shrink-1 bd-highlight" [ngStyle]="{color:isAdditional&&'yellow'}"  >{{math.floor(max-val)}}s</div>
  </div>

  <div class="d-flex bd-highlight" *ngIf="normalLoader &&max-val>=0" >
    <div class="p-1 w-100 bd-highlight"> <ngb-progressbar [max]="max" [value]="val"></ngb-progressbar></div>
    <div class="p-0 flex-shrink-1 bd-highlight">{{val}}%</div>  
  </div>

